import { Skeleton } from '../ds/components';
import { useIsMobile } from '../ds/hooks';
import styles from './ShellSkeleton.module.css';

/** Loading state of the shell while the session is fetched (no spinner: the page's own shapes). */
export function ShellSkeleton() {
  const mobile = useIsMobile();
  return (
    <div className={styles.frame} aria-busy="true" aria-label="Wird geladen">
      <div className={styles.topbar}>
        <Skeleton width={56} height={14} />
        {!mobile ? (
          <>
            <Skeleton width={64} height={12} />
            <Skeleton width={64} height={12} />
            <Skeleton width={64} height={12} />
          </>
        ) : null}
        <span className={styles.spacer} />
        {!mobile ? <Skeleton width={280} height={34} /> : null}
        <Skeleton variant="circle" width={34} />
        <Skeleton variant="circle" width={26} />
      </div>
      <div className={styles.body}>
        <Skeleton width={220} height={34} />
        <Skeleton variant="block" height={280} />
      </div>
    </div>
  );
}
